<template>
    <div class="COP">
        <h1>板式换热器压力数据</h1>
        <div class="line"></div>
        <div class="use">
            <div class="tab">
            </div>
            <div class="select">
                <el-select v-model="value">
                    <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="text">
            <div class="item-dom">
                <div class="dom" id="dom4"></div>
                <p>一次进口温度</p>
            </div>
            <div class="content">
                <p>二次进口温度</p>
                <p>{{ items[2].val }}℃</p>
                <p>二次进口压力</p>
                <p>{{ items[6].val }}MPa</p>
            </div>
            <div class="item-dom">
                <div class="dom" id="dom5"></div>
                <p>一次进口压力</p>
            </div>
        </div>
        <div class="footer">
            <div class="item">
                <p>一次出口温度</p>
                <p>{{ items[1].val }}℃</p>
            </div>
            <div class="item">
                <p>一次出口压力</p>
                <p>{{ items[5].val }}MPa</p>
            </div>
            <div class="item">
                <p>二次出口温度</p>
                <p>{{ items[3].val }}℃</p>
            </div>
            <div class="item">
                <p>二次出口压力</p>
                <p>{{ items[7].val }}MPa</p>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
export default {
    props: {
    },
    data() {
        return {
            myChart1: null,
            myChart2: null,
            value1: 27,
            value2: 55,
            cur: 0,
            items: [{
                    "name": "en_25.PV",
                    "val": 0
                },
                {
                    "name": "en_26.PV",
                    "val": 0
                },
                {
                    "name": "en_27.PV",
                    "val": 0
                },
                {
                    "name": "en_28.PV",
                    "val": 0
                },
                {
                    "name": "en_53.PV",
                    "val": 0
                },
                {
                    "name": "en_54.PV",
                    "val": 0
                },
                {
                    "name": "en_55.PV",
                    "val": 0
                },
                {
                    "name": "en_56.PV",
                    "val": 0
                }],
            // 下拉选择框
            options: [
                {
                    value: 1,
                    label: "1#板换",
                    names: "en_17.PV,en_18.PV,en_19.PV,en_20.PV,en_45.PV,en_46.PV,en_47.PV,en_48.PV"
                },
                {
                    value: 2,
                    label: "2#板换",
                    names: "en_21.PV,en_22.PV,en_23.PV,en_24.PV,en_49.PV,en_50.PV,en_51.PV,en_52.PV"
                }
            ],
            value: 1,
        }
    },
    mounted() {
        this.handleEchart()
        this.handleEchart1()
        this.handleAdd()
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                this.handleGetData()
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleAdd() {
            setInterval(() => {
                this.value += 1;
                if (this.value == this.options.length+1) {
                    this.value = 1;
                }
            }, 1000*60*5)
        },
        // 获取数据
        handleGetData() {
            getRequest("/api/realdata", {
                names: this.options[this.value - 1].names,
                token: sessionStorage.getItem("realTimeToken"),
                decimal: 2,
            }).then((res) => {
                if (res.code == 0) {
                    this.items = res.items
                    this.myChart1.setOption({
                        series: [{
                            data: [{
                                value: this.items[0].val
                            }]
                        }]
                    })
                    this.myChart2.setOption({
                        series: [{
                            data: [{
                                value: this.items[4].val
                            }]
                        }]
                    })
                }
            })
        },
        handleEchart() {
            // 1局部方法 echarts.init
            this.myChart1 = echarts.init(document.getElementById("dom4"));

            // 2 指定图表的配置项和数据 (书写配置项，设置图表的内容)
            let option = {
                series: [
                    {
                        type: 'gauge',
                        min: 10,
                        max: 100,
                        progress: {
                            show: true,
                            width: 5
                        },
                        axisLine: {
                            lineStyle: {
                                width: 5
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            length: 5,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            distance: 25,
                            color: '#999',
                            fontSize: 2
                        },
                        anchor: {
                            show: true,
                            showAbove: true,
                            size: 12,
                            itemStyle: {
                                borderWidth: 10
                            }
                        },
                        title: {
                            show: true,
                        },
                        detail: {
                            valueAnimation: true,
                            fontSize: 25,
                            color: '#fff',
                            offsetCenter: [0, '70%']
                        },
                        data: [
                            {
                                value: 4.15
                            }
                        ]
                    }
                ]
            };
            // 3 使用刚指定的配置项和数据显示图表。（添加到div中）
            this.myChart1.setOption(option);
            // 4 图表的响应式
            window.onresize = () => {
                this.myChart1.resize();
            };
        },
        handleEchart1() {
            // 1局部方法 echarts.init
            this.myChart2 = echarts.init(document.getElementById("dom5"));
            // 2 指定图表的配置项和数据 (书写配置项，设置图表的内容)
            let option = {
                series: [
                    {
                        type: 'gauge',
                        min: 0,
                        max: 1,
                        progress: {
                            show: true,
                            width: 5
                        },
                        axisLine: {
                            lineStyle: {
                                width: 5
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            length: 5,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            distance: 25,
                            color: '#999',
                            fontSize: 2
                        },
                        anchor: {
                            show: true,
                            showAbove: true,
                            size: 12,
                            itemStyle: {
                                borderWidth: 10,
                                color: '#6e7079'
                            }
                        },
                        title: {
                            show: false
                        },
                        detail: {
                            valueAnimation: true,
                            fontSize: 25,
                            color: '#fff',
                            offsetCenter: [0, '70%']
                        },
                        data: [
                            {
                                value: 4.15
                            }
                        ]
                    }
                ]
            };
            // 3 使用刚指定的配置项和数据显示图表。（添加到div中）
            this.myChart2.setOption(option);
            // 4 图表的响应式
            window.onresize = () => {
                this.myChart2.resize();
            };
        },
    }
}
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face {
    /*自定义文字名称*/
    font-family: "yj";
    /*字体文件的路径*/
    src: url("./1.TTF");
}

.COP::v-deep {
    height: 320px;

    h1 {
        margin: 15px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005EC9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .use {
        display: flex;
        justify-content: space-between;
        margin: 4px 0 0;

        .tab {
            display: flex;

            .tab-title {
                text-align: center;
                margin: 0 5px;
                width: 78px;
                height: 22px;
                border: 1px solid #00fff2;
                box-sizing: border-box;

                p {
                    display: inline-block;
                    width: 60px;
                    height: 22px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 22px;
                }

                &.active {
                    background: linear-gradient(122deg,
                            #0f65ea 0%,
                            #00d9ea 100%);
                    border: none;
                }
            }
        }

        .select {
            input {
                text-align: center;
                margin: 0 5px;
                width: 90px;
                height: 20px;
                box-sizing: border-box;
                background: linear-gradient(122deg, #0f65ea 0%, #00d9ea 100%);
                font-size: 14px;
                font-weight: 600;
                color: #ffffff;
                line-height: 20px;
                padding: 0 10px 0 5px;
                border-radius: 0px;
                border: none;
            }
        }
    }

    .text {
        margin-top: 10px;
        // height: 71%;
        display: flex
    }

    .item-dom {
        height: 150px;
        width: 30%;
        text-align: center;
        font-size: 17px;
        font-weight: 600;

        .dom {
            height: 130px;
            width: 100%;
        }

        p {
            color: #02bbef;
        }
    }



    .content {
        width: 40%;
        height: 150px;
        font-size: 17px;
        font-weight: 600;
        text-align: center;
        color: #fff;
        margin-top: 20px;

        p {
            margin: 5px 0;

            &:nth-child(2n) {
                color: #b7332e;
            }

            &:nth-child(2n-1) {
                color: #02bbef;
            }
        }
    }

    .footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;

        .item {
            width: 48%;
            text-align: center;
            font-size: 17px;
            font-weight: 600;
            display: flex;
            align-items: center;

            p {
                margin: 5px 0;

                &:nth-child(2n) {
                    color: #b7332e;
                }

                &:nth-child(2n-1) {
                    margin-right: 15px;
                    color: #02bbef;
                }
            }
        }
    }

    .el-input__icon {
        line-height: 20px;
    }
}
</style>